// extracted by mini-css-extract-plugin
export default {"cls1":"Cta-cls1_qm3","cls2":"Cta-cls2_DzJ Cta-cls1_qm3"};